module.exports = __webpack_public_path__ + "img/p-two-step-02.332af603.png";